import { render, staticRenderFns } from "./CookieBar.vue?vue&type=template&id=24250c04&"
import script from "./CookieBar.vue?vue&type=script&lang=js&"
export * from "./CookieBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24250c04')) {
      api.createRecord('24250c04', component.options)
    } else {
      api.reload('24250c04', component.options)
    }
    module.hot.accept("./CookieBar.vue?vue&type=template&id=24250c04&", function () {
      api.rerender('24250c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/CookieBar.vue"
export default component.exports